/**
 * Get supported card type from merchant config's payment constraints
 *  - paymentConstraints is an optional field in merchant config
 * @param {object} response
 * @returns {array} supported card brands
 */
const getCardBrands = response => {
  const paymentTypes =
    response?.data?.merchantConfig?.paymentConstraints?.paymentTypes?.paymentType ?? [];
  const cardBrands = (paymentTypes.length > 0 && paymentTypes.map(pType => pType.cardBrand)) || [];
  return cardBrands;
};
export default getCardBrands;
